import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';


@Component({
  selector: 'app-legend-labels',
  templateUrl: './legend-labels.component.html',
  styleUrls: ['./legend-labels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

})
export class LegendLabelsComponent {
  @Input() chartData;
  @Output() removeChartClicked = new EventEmitter<number>();
  @Input() columns: number = 3;
  @Input() showLastPoint: boolean = false;


  clickedIndexes: number[] = [];

  calculateTotal(dataArray: number[]): number {
    return dataArray.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  }
  lastPoint(dataArray: number[]): number {
    return dataArray[dataArray.length-1] ? dataArray[dataArray.length-1] : 0;
  }

  chartToggleClick(index: number) {
    this.removeChartClicked.emit(index)
    if (this.clickedIndexes.includes(index)) {
      this.clickedIndexes = this.clickedIndexes.filter((i) => i !== index);
    } else {
      this.clickedIndexes.push(index);
    }
  }
}
